import { Link } from 'react-router-dom';

const SIZE_CLASS = {
  header: 'lumora-brand--header',
  md: 'lumora-brand--md',
  lg: 'lumora-brand--lg',
  hero: 'lumora-brand--hero',
};

export default function Logo({ className = '', size = 'md', link = true }) {
  const Wrapper = link ? Link : 'div';
  const wrapperProps = link ? { to: '/' } : {};

  return (
    <Wrapper
      {...wrapperProps}
      className={`lumora-brand group inline-flex shrink-0 ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
      aria-label="LUMORA — Curated Living Spaces"
    >
      <div className="lumora-brand__panel transition-transform duration-300 group-hover:scale-[1.02]">
        <span className="lumora-brand__title" aria-hidden>
          LUMORA
        </span>
        <span className="lumora-brand__tagline" aria-hidden>
          CURATED LIVING SPACES
        </span>
        <div className="lumora-brand__divider" aria-hidden>
          <span className="lumora-brand__divider-line" />
          <span className="lumora-brand__divider-gem" />
          <span className="lumora-brand__divider-line" />
        </div>
      </div>
    </Wrapper>
  );
}
